import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import omit from "lodash/omit"

import { patchColumnData, toggleSelectOpen } from "app/static/frontend/sheets/sheet-action-creators"

import { StafferSelect } from "app/static/frontend/selects/containers/PieSelect"
import { CellWrapper } from "app/static/frontend/sheets/components/cells/MantineCells/CellWrapper"

const UnconnectedStafferSelectCell = ({
    children,
    sheetId,
    rowId,
    columnId,
    editing,
    isPublicSheet,
    menuShouldScrollIntoView,
    row,
    ...props
}) => (
    <CellWrapper truncate={false} {...omit(props, ["patchColumnData"])}>
        {editing && !isPublicSheet ? (
            <StafferSelect
                id={`${sheetId}:${rowId}:${columnId}`}
                permanentFilter={{
                    person: rowId,
                }}
                onChange={({ person, ...staffer }) =>
                    props.patchColumnData({
                        id: sheetId,
                        columnId,
                        rowId,
                        newValue: { person: rowId, ...staffer, chosen: true },
                        row,
                    })
                }
                value={children?.id}
                clearable={false}
                autoload={false || editing}
                searchify={false}
                onOpen={() => {
                    props.toggleSelectOpen(sheetId, true)
                }}
                onClose={() => {
                    props.toggleSelectOpen(sheetId, false)
                }}
                menuShouldScrollIntoView={menuShouldScrollIntoView}
            />
        ) : (
            children?.["name"]
        )}
    </CellWrapper>
)

UnconnectedStafferSelectCell.propTypes = {
    children: PropTypes.object.isRequired,
    patchColumnData: PropTypes.func.isRequired,
    rowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    columnId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    toggleSelectOpen: PropTypes.func.isRequired,
    sheetId: PropTypes.string.isRequired,
    isPublicSheet: PropTypes.bool,
    editing: PropTypes.bool.isRequired,
    menuShouldScrollIntoView: PropTypes.bool,
}

UnconnectedStafferSelectCell.defaultProps = {
    isPublicSheet: false,
    menuShouldScrollIntoView: false,
}

export const StafferSelectCell = connect(null, { patchColumnData, toggleSelectOpen })(UnconnectedStafferSelectCell)
